/**
 * uploadWorkspaceBlob — sl-ngy4.3.4.
 *
 * TUS direct upload wrapped as a promise returning a complete `BlobReference`
 * (kind/blobId/filename/mimeType/size). This is the frontend source of truth
 * for file → BlobReference conversion outside editor DI.
 */

import { uploadWorkspaceFileViaTus } from '@affine/core/modules/workspace/utils/tus-direct-upload';
import { fileWithResolvedMimeType } from '@affine/core/utils/blob-file-type';
import type { BlobReference } from '@streamlain/field-types';

export async function uploadWorkspaceBlob(
  workspaceId: string,
  file: File,
  options: { docId?: string | null } = {}
): Promise<BlobReference> {
  const uploadFile = await fileWithResolvedMimeType(file);
  const blobId = await uploadWorkspaceFileViaTus({
    workspaceId,
    file: uploadFile,
    ...(options.docId ? { docId: options.docId } : {}),
  });
  if (!blobId) {
    throw new Error('Streamable blob upload requires tus direct upload');
  }

  return {
    kind: 'blob',
    blobId,
    filename: uploadFile.name,
    mimeType: uploadFile.type || 'application/octet-stream',
    size: uploadFile.size,
  };
}
